import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "reactstrap";
import codeIcon from "../images/code-icon.svg";

const Skills = () => {
  const sectionTitles = ['Web Developer', 'Blockchain Developer', 'Data Analytics and Machine Learning']
  const frontEndSkills = {
    learnt: 'JavaScript, Typescipt, Python, HTML, CSS, React.js, Node.js, SQL, Swagger and more...',
    use: [
      'Redux',
      'Redux dev tools',
      'React Router',
      'memoizing',
      'Hooks',
      'styled-components',
      'Context API',
      'React-query',
      'React query dev tools',
      'RTK',
      'Storybook',
      'Husky',
      'Axios',
      'npm',
      'Git',
      'Visual Studio Code',
      'Github',
      'Bootstrap',
      'Chrome Developer Tools',
      'And more...',
    ]
  };

  const machineLearningSkills = {
    learnt: 'Python, Pandas,scikit-learn, Jupyter Notebook, Machine Learning, SQL, Regression Analysis, Clustering and more...',
    use: [
      'Jupyter Notebook',
      'Pandas',
      'scikit-learn',
      'Python',
      'Regression Analysis',
      'K-means Clustering',
      'Machine Learning',
      'Github',
      'And more...',
    ]
  };

  const blockchainSkils = {
    titleText: "I'm learning:",
    expTitle: "I'm experimenting on:",
    learnt: 'solidity, web3-react, ethers.js',
    use: [
      'hardhat',
      'truffle',
      'ganache',
      'infura',
      'remix',
      'useDApp',
      'metamask',
      'ropsten',
      'smart contracts'
    ]
  };

  const skills = [frontEndSkills, blockchainSkils, machineLearningSkills ]

  return (
    <>
      <div id="skills">
        <Container>
          <Row>
            <Col>
              {
                sectionTitles.map((section, key) => <>
                  <img alt="code-con" className="code-icon" src={codeIcon} />
                  <h1>{section}</h1>
                  <h2>{skills[key]?.titleText||"Experience using:"}</h2>
                  <p>
                    {skills[key]?.learnt}
                  </p>
                  <h2>{skills[key]?.expTitle||"I experimented with:"}</h2>
                  <ul>
                    {skills[key]?.use.map((skill) => <li>{skill}</li>)}
                  </ul>
                </>
                )
              }
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
export default Skills